export default "__VITE_ASSET__COZ8aB4o__"